<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="ruleCustom.pkid > 0 ? '编辑':'新建'"
        width="1200px"
        top="5vh"
        @close="$reset('form')">
      <el-form ref="form" :model="ruleCustom" :rules="ruleValidate" label-width="100px">
        <el-form-item v-if="ruleCustom.pkid>0" label="编号" prop="ruleName">
          <el-input v-model="ruleCustom.ruleName" readonly/>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="使用类别" prop="ruleCategory">
              <el-select v-model="ruleCustom.ruleCategory" :disabled="ruleCustom.pkid>0">
                <el-option label="蒂升MCX订单" value="10"/>
                <el-option label="散件导入" value="20"/>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="自定义类型" prop="customType">
              <el-select v-model="ruleCustom.customType" :disabled="ruleCustom.pkid>0">
                <el-option label="客户配置物料" :value="0"/>
                <el-option label="控制柜证书编号" :value="1"/>
                <el-option label="一级参数代码" :value="2"/>
                <el-option label="脉冲数" :value="3"/>
                <el-option label="电气原理图1" :value="4"/>
                <el-option label="电气原理图2" :value="5"/>
                <el-option label="UCMP证书编号" :value="6"/>
                <el-option label="马达额定转速" :value="7"/>
                <el-option label="核对人" :value="8"/>
                <el-option label="审核人" :value="9"/>
                <el-option label="板载化" :value="10"/>
                <el-option label="木箱规格" :value="11"/>
                <el-option label="包装箱" :value="12"/>
                <el-option label="随机文件" :value="13"/>
                <el-option label="ARD" :value="14"/>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="自定义编号" prop="customerMaterialNo">
              <el-input v-model="ruleCustom.customerMaterialNo"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="自定义描述" prop="customerMaterialDesc">
              <el-input v-model="ruleCustom.customerMaterialDesc"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="数量" prop="qty">
              <el-input v-model="ruleCustom.qty"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位" prop="unit">
              <el-input v-model="ruleCustom.unit"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="表达式" prop="ruleExpression">
              <el-input type="textarea" rows="5" v-model="ruleCustom.ruleExpression"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注" prop="note">
              <el-input type="textarea" v-model="ruleCustom.note"/>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
      <span slot="footer">
      <el-button @click="dialogVisible=false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">
        保存
      </el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";

  export default {
    name: "RuleCustomEdit",
    // components: {ProductControlBoxSelect},
    data() {
      return {
        dialogVisible: false,
        dataTypes: constant.toSelect(constant.dataType),
        valueTypes: constant.toSelect(constant.valueType),
        contentLoading: false,
        submitLoading: false,
        isCopy: 0,
        ruleCustom: {
          pkid: 0,
          ruleName: "",
          ruleCategory: "10",
          ruleType: 10,
          customType: 0,
          customerMaterialDesc: "",
          customerMaterialNo: "",
          status: 0,
          qty: 1,
          unit: "PC",
          ruleExpression: "",
          outputExpression: "0",
          note: "",
        },
        ruleValidate: {
          ruleExpression: [{required: true, message: "表达式不能为空", trigger: "blur"}],
        },
      };
    },
    methods: {
      open: function(id, isCopy) {
        if (isCopy === 1) {
          this.isCopy = 1;
        }
        this.ruleCustom.pkid = id;
        if (id) {
          this.getData(id);
        }
        this.dialogVisible = true;
      },
      getData(id) {
        this.$http
            .get("basic", `ruleCustoms/${id}`)
            .then(resp => {
              console.log(resp);
              if (resp.success) {
                this.ruleCustom = resp.data;
              }
            });
      },
      handleSubmit() {
        let isAdd = 1;
        if (this.ruleCustom.pkid) {
          isAdd = 0;
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
                .post("basic", `ruleCustoms/save/${isAdd}`, this.ruleCustom)
                .then((resp) => {
                  if (resp.success) {
                    this.submitLoading = false;
                    this.dialogVisible = false;
                    this.$emit("save-success");
                    this.$message.success("保存成功");
                  } else {
                    this.$message.error(resp.message);
                    this.submitLoading = false;
                  }

                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
